import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class AppBackdropService {
  private active = new BehaviorSubject<number>(0);
  private clicked = new Subject<void>();

  public isActive$: Observable<boolean>;
  public isClicked$ = this.clicked.asObservable();

  constructor() {
    this.isActive$ = this.active.pipe(map(activations => activations > 0));
  }

  public onClick() {
    this.clicked.next();
  }

  public activate() {
    this.active.next(this.active.getValue() + 1);
  }

  public deactivate() {
    if (this.active.getValue() > 0) {
      this.active.next(this.active.getValue() - 1);
    }
  }
}
